export const getColumns = () => {

    return [
        {
            Header: "Email",
            Footer: "Email",
            accessor: "useremail",
            sticky: "left",
        },
        {
            Header: "Product Description",
            Footer: "Product Description",
            accessor: "productdescription",
        },
        {
            Header: "Batch No.",
            Footer: "Batch No.",
            accessor: "batchno",
        },
        {
            Header: "Quantity",
            Footer: "Quantity",
            accessor: "quantity",
        },
        {
            Header: "Value",
            Footer: "Value",
            accessor: "value",
        },
        {
            Header: "Date Time",
            Footer: "Date Time",
            accessor: "datetime",
        },
        {
            Header: "Download",
            Footer: "Download",
            accessor: "download",
        },
    ];
};

